import React, { useState } from "react";
import "./CohortPageCopy.scss";

const CohortPageCopy = () => {
  return (
    <div className="cohort-page-copy">
      {/* LEFT SECTION - COHORT LIST */}
      <div className="cohort-list">
        <div className="header">
          <input type="text" placeholder="Search cohort by name" />
          <button className="add-btn">+ Cohort</button>
        </div>

        <div className="tabs">
          <button className="active">Suggested Cohort</button>
          <button>Custom Cohort</button>
        </div>

        <CohortCard
          title="Large Asset Banks"
          subtitle="System-defined group of banks with high asset size as the baseline."
          range="$100M – $800M"
          institutions={154}
          avg={82}
          percentile="71st"
          active
        />

        <CohortCard
          title="West Coast Growth Banks"
          subtitle="Banks in the western region with small to mid-level assets."
          range="$50M – $500M"
          institutions={154}
          avg={82}
          percentile="71st"
        />

        <CohortCard
          title="Southeast Mid-size Banks"
          subtitle="Mid-tier banks from southern states grouped to track regional lending."
          range="$100M – $800M"
          institutions={154}
          avg={82}
          percentile="71st"
        />
      </div>

      {/* CENTER SECTION - FILTERS */}
      <div className="filters">
        <h3>Filters</h3>

        <div className="filter-section">
          <label>Asset Size</label>
          <div className="asset-inputs">
            <input type="text" value="$100M" readOnly />
            <span>-</span>
            <input type="text" value="$800M" readOnly />
          </div>
        </div>

        <div className="filter-section">
          <label>State</label>
          <input className="search-box" type="text" placeholder="Search states" />

          <div className="chip-row">
            <span className="chip">Alaska ✕</span>
            <span className="chip">California ✕</span>
          </div>

          <div className="checkbox-group">
            <label><input type="checkbox" /> Arkansas</label>
            <label><input type="checkbox" defaultChecked /> California</label>
            <label><input type="checkbox" /> Oregon</label>
          </div>
        </div>

        <div className="filter-section">
          <label>Additional Institution</label>
          <input className="search-box" type="text" placeholder="Search institutions" />

          <div className="institution-list">
            <span className="institution-item">Axos Bank</span>
            <span className="institution-item">Bank of America</span>
            <span className="institution-item">BMO Bank</span>
          </div>
        </div>

        <div className="footer">
          <button className="clear-btn">Clear all</button>
          <button className="apply-btn">Apply Filters</button>
        </div>
      </div>

      {/* RIGHT SECTION - VIEW COHORT */}
      <div className="view-cohort">
        <h3>View Your Cohort</h3>

        <div className="summary-card">
          <h4>Large Asset Size Cohort</h4>
          <p>A filtered group of banks based on your selected criteria.</p>

          <div className="stats-row">
            <div>
              <label>Percentile</label>
              <strong>56th</strong>
            </div>
            <div>
              <label>Cohort Average</label>
              <strong>78</strong>
            </div>
            <div>
              <label>Institutions</label>
              <strong>412</strong>
            </div>
          </div>
        </div>

        <div className="bank-list">
          <h5>Bank Names in Cohort</h5>

          <div className="bank-group">
            <span className="letter">A</span>
            <span className="bank">Axos Bank</span>

            <span className="letter">B</span>
            <span className="bank">Bank of America</span>
            <span className="bank">BMO Bank</span>

            <span className="letter">C</span>
            <span className="bank">CitiBank</span>
            <span className="bank">Cathay United Bank</span>
          </div>
        </div>

        <div className="removed-section">
          <input type="text" placeholder="Search banks in the cohort" />
          <div className="removed-card">
            <div className="top">
              <strong>Removed Institutions</strong>
              <button>Clear</button>
            </div>
            <span className="bank">Huntington National Bank</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CohortCard = ({ title, subtitle, range, institutions, avg, percentile, active }) => {
  return (
    <div className={`cohort-card ${active ? "active" : ""}`}>
      <h4>{title}</h4>
      <p>{subtitle}</p>
      <div className="range">{range}</div>

      <div className="stats">
        <div>
          <label>Institutions</label>
          <span>{institutions}</span>
        </div>
        <div>
          <label>Cohort Average</label>
          <span>{avg}</span>
        </div>
        <div>
          <label>Percentile</label>
          <span>{percentile}</span>
        </div>
      </div>
    </div>
  );
};

export default CohortPageCopy;
